import React from 'react';

const FileUploadWrapper = ({ fileInputProps }) => {
    return <>
    <div className='fileupload-wrapper'>
        <span className='btn'>Select Image</span>
        <input type="file" className='myfile' accept='image/png, image/jpeg, image/jpg' { ...fileInputProps } />
    </div>
    <p>File Size <i>Maximum 1MB</i></p>
    <p>File Extension <i>JPEG , PNG</i></p>
  </>
}

export default FileUploadWrapper;